<template>
  <tooltip v-if="hasPermission(permission)" label="Resume" type="small" placement="top">
    <button type="button" @click="onClick" class="button is-warning">
      <span class="icon">
        <i class="fa fa-refresh"></i>
      </span>
    </button>
  </tooltip>
</template>

<script>
    import mixin from 'components/mixin';

    export default {
        mixins: [mixin],
        name: "reset-button",
        props: {
            permission: Array
        },
        methods: {
            onClick() {
                this.$emit('click');
            }
        }
    }
</script>

<style scoped>

</style>